import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Stream from "flarum/common/utils/Stream";

export default class AddSiteModal extends Modal {
  static readonly isDismissibleViaBackdropClick = false;
  private params: any = {
    title: Stream(),
    anotherName: Stream(),
    establishmentDate: Stream(),
    desc: Stream(),
    officialGroup: Stream(),
    accessDifficulty: Stream(),
    torrentsNum: Stream(),
    officialAccess: Stream(),
    deletionTime: Stream(),
    donationPrice: Stream(0),
    vipPrice: Stream(0),
    inviteLevel: Stream(),
    invitePrice: Stream(0),
    iyuuFavour: Stream(0),
    transmissionFavour: Stream(0),
    siteStatus: Stream(0),
    auxiliaryTools: Stream()
  }

  oninit(vnode) {
    super.oninit(vnode);

    Object.keys(this.attrs.data).map(item => {
      this.params[item] = Stream(this.attrs.data[item]);
    })
  }

  title() {
    return this.params.siteId ? app.translator.trans('mattoid-pt-site-information.forum.add-site') : app.translator.trans('mattoid-pt-site-information.forum.edit-site');
  }

  className(): string {
    return '';
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <div id="addSite" className="Form-group">
            <div>
              <div className="row">
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.title")}</label>
                  <input required
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.title}/>
                </div>
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.another-name")}</label>
                  <input required
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.anotherName}/>
                </div>
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.establishment-date")}</label>
                  <input
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         placeholder="0000-00-00"
                         bidi={this.params.establishmentDate}/>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.desc")}</label>
                  <input
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.desc}/>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.official-group")}</label>
                  <input
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.officialGroup}/>
                </div>
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.access-difficulty")}</label>
                  <input required
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.accessDifficulty}/>
                </div>
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.torrents-num")}</label>
                  <input required
                         class="FormControl"
                         type="number"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.torrentsNum}/>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.official-access")}</label>
                  <input
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.officialAccess}/>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.deletion-time")}</label>
                  <input required
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.deletionTime}/>
                </div>
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.donation-price")}</label>
                  <input required
                         class="FormControl"
                         type="number"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.donationPrice}/>
                </div>
                <div className="col-md-4">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.vip-price")}</label>
                  <input required
                         class="FormControl"
                         type="number"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.vipPrice}/>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.invite-level")}</label>
                  <input required
                         class="FormControl"
                         type="text"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.inviteLevel}/>
                </div>
                <div className="col-md-6">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.invite-price")}</label>
                  <input required
                         class="FormControl"
                         type="number"
                         step="1"
                         min="0"
                         style=""
                         bidi={this.params.invitePrice}/>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <label className="Site-Label">{app.translator.trans("mattoid-pt-site-information.forum.info.auxiliary-tools")}</label>
                  <input required
                         class="FormControl"
                         type="text"
                         style=""
                         placeholder="IYUU | 其他"
                         bidi={this.params.auxiliaryTools}/>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Switch
                    state={this.params.transmissionFavour()}
                    onchange={(val) => {
                      this.params.transmissionFavour = Stream(Number(val))
                    }}
                  >
                    {app.translator.trans("mattoid-pt-site-information.forum.info.transmission-favour")}
                  </Switch>
                </div>
                <div className="col-md-6">
                  <Switch
                    state={this.params.siteStatus()}
                    onchange={(val) => {
                      this.params.siteStatus = Stream(Number(val))
                    }}
                  >
                    {app.translator.trans("mattoid-pt-site-information.forum.info.site-close")}
                  </Switch>
                </div>
              </div>

              <div className="center">
                {
                  Button.component({
                    className: 'Button Button--primary',
                    type: 'submit',
                    loading: this.loading,
                  }, app.session.user.attribute('canSiteModerateView') ? this.params.siteId ? app.translator.trans("mattoid-pt-site-information.forum.edit-site") : app.translator.trans("mattoid-pt-site-information.forum.add-site") : app.translator.trans("mattoid-pt-site-information.forum.button"))
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/pt/site/info',
      body: this.params
    }).then(
      (res) => {
        this.params = res.data.attributes
        this.loading = false;
        this.hide();
        m.redraw();
      },
      (result) => {
        this.loading = false;
        this.handleErrors(result);
      });
  }
}
